'use client';

import { useRef, useEffect } from 'react';
import { TextLink, LogoTreatsRewards, Image } from '@petsmart-ui/sparky';
import { useCart } from '@libs/common-next';
import { CurrentTierLevel } from '@libs/common-types';
import { LoggedInNavList } from './LoggedInNavList';
import { formatCurrency, navigationItems, getTierImage } from './utils';

type LoggedInProps = {
    firstName?: string;
    loyaltyPoints?: number;
    currentTierLevel?: CurrentTierLevel;
    availableDollars?: number;
};

export function LoggedIn({
    firstName = '',
    loyaltyPoints = 0,
    currentTierLevel = 'member',
    availableDollars = 0,
}: Readonly<LoggedInProps>) {
    const { clearCart } = useCart();
    const link = useRef<string>('');

    useEffect(() => {
        if (typeof window !== 'undefined') {
            link.current = window.location.origin;
        }
    }, []);

    if (!firstName) {
        return null;
    }
    const tierImagename = getTierImage(currentTierLevel);
    return (
        <div className="logged-in">
            <div className="treats-container">
                <div className="member">
                    <span> Hi {firstName}!</span>
                    <span className="tier-status">
                        {currentTierLevel?.charAt(0).toUpperCase() + currentTierLevel?.slice(1)}
                        <Image
                            className="tier-image"
                            data-testid="member-image"
                            src={tierImagename}
                            alt={currentTierLevel}
                        />
                    </span>
                </div>
                <div className="loyalty">
                    <span className="treats-points"> {formatCurrency(availableDollars)} Treats balance</span>
                    <span className="dollar-points">
                        (
                        {` ${new Intl.NumberFormat('en-US', {
                            maximumFractionDigits: 0,
                        }).format(loyaltyPoints || 0)} `}
                        ) points
                    </span>
                </div>
                <div className="treats-rewards">
                    <LogoTreatsRewards className="treats-logo" />
                    <TextLink href="/treats-rewards" className="benefits">
                        See benefits
                    </TextLink>
                </div>
            </div>
            <LoggedInNavList linkRef={link} clearCart={clearCart} items={navigationItems} />
        </div>
    );
}
